// extracted by extract-css-chunks-webpack-plugin
module.exports = {"video":"_2We76Y aLs3Nr"};